import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import styles from './request-account-style.module.css';
import { createAccountRequest, ACCOUNT_TYPES, ACCOUNT_AREAS } from '../firebase/firebase';

export function RequestAccount({setShowNavBar}) {
    const navigation = useNavigate();

    useEffect(() => setShowNavBar(false));

    const [email, setEmail] = useState('') 
    const [firstName, setFirstName] = useState('') 
    const [lastName, setLastName] = useState('') 
    const [phoneNumber, setPhoneNumber] = useState('') 
    const [accountType, setAccountType] = useState('')
    const [accountArea, setAccountArea] = useState('');

    useEffect(() => {
        const select = document.getElementById('area');
        select.selectedIndex = 0;
        setAccountArea('');
    }, [accountType])

    const handleSubmit = (e) => {
        e.preventDefault();

        let elementID = null;

        if(firstName === '') {
            elementID = styles.first_name;
        } else if (lastName === '') {
            elementID = styles.last_name;
        } else if (email === '') {
            elementID = styles.email;
        } else if (phoneNumber === '') {
            elementID = styles.phone;
        } else if (accountType === '') {
            elementID = 'type';
        } else if (accountArea === '') {
            elementID = 'area';
        }

        if(elementID != null) {
            const element = document.getElementById(elementID);
            element.focus();
            element.classList.add(styles.empty_field);        
        } else {
            createAccountRequest({email: email, first_name: firstName, last_name: lastName, phone_number: phoneNumber, account_type: accountType, account_area: accountArea, permissions: ['view-home']})
                .then(() => {
                    navigation('/request-submitted');
                }).catch((reason) => {
                    console.log("Catch Reason:", reason);
                })
        }      
    }

    const phoneKeydownListener = (evt) => {
        if (!(evt.ctrlKey || evt.key.length > 1 || /[0-9.]/.test(evt.key)))
            evt.preventDefault();
    }

    const phoneKeyUpListener = (evt) => {
        const digits = evt.target.value.replace(/\D/g,'').substring(0,10);
        const areaCode = digits.substring(0,3);
        const prefix = digits.substring(3,6);
        const suffix = digits.substring(6,10);

        if(digits.length > 6) {evt.target.value = `(${areaCode}) ${prefix}-${suffix}`;}
        else if(digits.length > 3) {evt.target.value = `(${areaCode}) ${prefix}`;}
        else if(digits.length > 0) {evt.target.value = `(${areaCode}`;}
    }

    return (
        <div className={styles.container}>
            <div className={styles.signup_container}>
                <div className={styles.details}>
                    <img className={styles.icon} src="/images/logo/chautauqua-interconnect-icon.svg" alt="The Chautauqua Interconect Logo"/>
                    <h1>Chautauqua Interconnect</h1>
                    <div className={styles.text}>
                        To ensure proper use of our plaform, we do not allow persons to create their own account. To receive and account, please fill out the below information. If your request is approved, you will recieve an email shortly with a link to create your account.
                    </div>
                </div> 
                <form className={styles.form}>

                    <div id={styles.name_fields}>
                        <label htmlFor={styles.first_name} id={styles.first_name_label}>First Name<span style={{color: 'red'}}>*</span></label>
                        <input className={styles.input} type="text" id={styles.first_name} autoComplete="given-name" onChange={(e) => {setFirstName(e.target.value); e.target.classList.remove(styles.empty_field);}} required/>
                        <label htmlFor={styles.last_name} id={styles.last_name_label}>Last Name<span style={{color: 'red'}}>*</span></label>
                        <input className={styles.input} type="text" id={styles.last_name} autoComplete="family-name" onChange={(e) => {setLastName(e.target.value); e.target.classList.remove(styles.empty_field);}} required/>
                    </div>
                    
                    <div id={styles.contact_fields}>
                        <label htmlFor={styles.email} id={styles.email_label}>Email Address<span style={{color: 'red'}}>*</span></label>
                        <input className={styles.input} type="email" id={styles.email} autoComplete="email" onChange={(e) => {setEmail(e.target.value); e.target.classList.remove(styles.empty_field);}} required placeholder='example@webpage.com'/>
                        <label htmlFor={styles.phone} id={styles.phone_label}>Phone Number<span style={{color: 'red'}}>*</span></label>
                        <input className={styles.input} type="tel" id={styles.phone} autoComplete="tel-national" onChange={(e) => {setPhoneNumber(e.target.value); e.target.classList.remove(styles.empty_field);}} required onKeyDown={(e) => phoneKeydownListener(e)} onKeyUp={(e) => phoneKeyUpListener(e)} placeholder='(123) 456-7890'/>
                    </div>

                    <label htmlFor="type">Account Type<span style={{color: 'red'}}>*</span></label>
                    <select className={styles.type} type="text" id="type" onChange={(e) => {setAccountType(e.target.value); e.target.classList.remove(styles.empty_field);}} defaultValue={''}>
                        <option value={''} disabled hidden>-- Choose Type --</option>
                        {
                            ACCOUNT_TYPES.map(type => <option>{type}</option>)
                        }
                    </select>

                    <label htmlFor="area">Account Area<span style={{color: 'red'}}>*</span></label>
                    <select className={styles.area} type="text" id="area" onChange={(e) => {setAccountArea(e.target.value); e.target.classList.remove(styles.empty_field);}} defaultValue={''}>
                        <option value={''} disabled hidden>-- Choose Area --</option>
                        {
                            ACCOUNT_AREAS[accountType.toLocaleLowerCase().split(' ')[0]]?.map(role => <option>{role}</option>)
                        }
                    </select>
                    
                    <p style={{color: 'red', margin: '16px 0 0 0'}}>* Indicates required field</p>
                    <div>
                        <button className={styles.request_btn} onClick={handleSubmit}>Submit</button>
                    </div>                    
                </form>              
            </div>
        </div>        
    )
}

export function RequestSubmitted({setShowNavBar}) {
    useEffect(() => setShowNavBar(false));
    return (
        <div className={styles.submitted_container}>
            <div className={styles.submitted_center}>
                <img className={styles.icon} src="/images/logo/chautauqua-interconnect-icon.svg" alt="The Chautauqua Interconect Logo"/>
                <h1>Your account request has been submitted</h1>
                <p>If we approve of your request, you will recieve an email with a link to finish creating your account.</p>
                <p>We should process your request within the workday.<br/>While you wait, you can watch <a href='https://youtu.be/3xPkwNu2o8g?si=zDQPe36trF5YF0MI' target='_blank' rel="noreferrer">this video</a> of nature!</p>
            </div>
        </div>
        
    )
}